
import React, { useEffect, useState } from 'react';

import useWizardFormCtx from '../../../ctx-provider/useWizardFormCtx';
import BankIbanField from '../../../../../cmp/input/BankIbanField';
import useInputSubmitValidator, { generateValidatorId } from '../../../../../../form/input/useInputSubmitValidator';
import BankIbanValidator from './BankIbanValidator';
import FormBo from '../../FormBo';
import StringUtil from '../../../../../../app/util/StringUtil';
import useGetBank from '../../../../../../consumer/bank/useGetBank';
import BankinstitutValidator from './BankinstitutValidator';
import BankViewDto from '../../../../../../consumer/bank/dto/BankViewDto';
import Bankinstitut from './Bankinstitut';
import BankLastschriftErteilen from './BankLastschriftErteilen';
import TransitionCollapse from '../../../../../transition/TransitionCollapse';
import LoadingSymbol from '../../../../../cmp/loading/LoadingSymbol';
import { Typography } from '@material-ui/core';
import ErrorMessage from '../../../../../cmp/message/ErrorMessage';
import GtmFormularfeldId from '../../../../../../gtm/types/GtmFormularfeldId';

const SUPPORTED_COUNTRY = 'DE';

export const importBankIban = (bankIban: string) => {
    if (bankIban && bankIban.startsWith(SUPPORTED_COUNTRY)) {
        // prepareImportValue
        const actuValue = StringUtil.replaceNonNumeric(bankIban);
        if (new BankIbanValidator(actuValue).validate().error === false) {
            return actuValue;
        }
    }

    return undefined;
}


export const exportBankIban = (bo: FormBo) => {
    // Nur Zahlen und Buchstaben
    return prepareExportValue(bo.bankIban);
};

const prepareExportValue = (value?: string) => {
    const actuValue = StringUtil.replaceNonAplphanumeric(value);
    return StringUtil.isBlank(actuValue) ? undefined : (SUPPORTED_COUNTRY + actuValue);
}

const VALIDATOR_ID_IBAN = generateValidatorId("Antrag-BankIban");
const VALIDATOR_ID_BANKINSTITUT = generateValidatorId("Antrag-BankBankinstititut");

const Bank = () => {
    // *** Formulardaten werden geladen
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();

    const { loadBank, loading } = useGetBank();
    const [bank, setBank] = useState<BankViewDto>();
    const [iban, setIban] = useState(wizardFormBo.antrag.bankIban);

    // *** Validator wird initialisiert
    const { validationState, fireFieldValidation: fireFieldValidationIban } = useInputSubmitValidator(VALIDATOR_ID_IBAN, new BankIbanValidator(iban));
    const { validationState: validationStateBank, fireFieldValidation: fireFieldValidationBank } = useInputSubmitValidator(VALIDATOR_ID_BANKINSTITUT, new BankinstitutValidator(bank));

    const loadBankdaten = async (iban: string) => {
        // *** Validate Bank
        // Die IBAN aus der Oberflaeche enthaehlt Leerzeichen und muss fuer den Dienst aufbereitet werden.
        const expValue = prepareExportValue(iban);

        const bank = expValue ? await loadBank(expValue) : undefined;
        setBank(bank)
        fireFieldValidationBank(new BankinstitutValidator(bank));
    }


    // *********************
    // init
    // *********************
    useEffect(() => {
        if (iban && validationState.error !== true) {
            loadBankdaten(iban);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const Loading: React.FC = () => {
        return (
            <div style={{ display: 'flex' }}>
                <LoadingSymbol />

                <Typography variant='caption' color='textPrimary' style={{ marginLeft: 10 }} >
                    Bankdaten werden ermittelt
                </Typography>
            </div>);
    };

    // ****************************
    // Handle on blur
    // ****************************
    // Validierung
    const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        // Die Bank wird zuruckgesetzt und neu ermittelt
        setBank(undefined);

        const iban = event.target.value;
        wizardFormBo.antrag.bankIban = iban;
        fireWizardFormBo(wizardFormBo);

        // *** Validate IBAN
        if (fireFieldValidationIban(new BankIbanValidator(iban)) === true) {
            loadBankdaten(iban);
        }
    }

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIban(event.target.value);
    }

    return (
        <div>
            <BankIbanField id="bankIban" idGtm={GtmFormularfeldId.vnBankIban} label="IBAN"
                value={iban}
                onBlur={handleOnBlur}
                onChange={handleOnChange}
                error={validationState.error || validationStateBank.error}
                helperText={validationState.message}
            />

            <div style={{ height: 30, marginTop: 10 }}>
                {loading && <Loading />}
                {!loading && validationStateBank.error && <ErrorMessage message={validationStateBank.message} />}
            </div>

            <TransitionCollapse show={!!bank}>
                <div>
                    <Bankinstitut loading={loading}
                        bank={bank} />
                </div>

                <div style={{ marginTop: 30 }}>
                    <BankLastschriftErteilen />
                </div>
            </TransitionCollapse>

        </div >
    );
}

export default Bank;